import { render, staticRenderFns } from "./LearningFaceMonitoringPage.vue?vue&type=template&id=0232e667&scoped=true"
import script from "./LearningFaceMonitoringPage.vue?vue&type=script&lang=js"
export * from "./LearningFaceMonitoringPage.vue?vue&type=script&lang=js"
import style0 from "./LearningFaceMonitoringPage.vue?vue&type=style&index=0&id=0232e667&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0232e667",
  null
  
)

export default component.exports